<div class="spaces-container">
  <!-- Header -->
  <div class="spaces-header">
    <div class="title-section">
      <h1>Workspaces</h1>
      <p class="subtitle">Manage your workspaces and collaboration</p>
    </div>
    <div class="actions-section">
      <p-button 
        label="New workspace" 
        icon="pi pi-plus"
        (click)="createNewSpace()">
      </p-button>
    </div>
  </div>

  <!-- Search -->
  <div class="search-section">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input 
        pInputText 
        type="text" 
        placeholder="Search workspaces..."
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        class="search-input">
    </div>
  </div>

  <!-- Table -->
  <div class="table-section">
    <p-table 
      [value]="filteredSpaces()" 
      [loading]="loading()"
      styleClass="spaces-table">
      
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Created by</th>
          <th>Your role</th>
          <th>
            Created at 
            <i class="pi pi-sort-amount-down"></i>
          </th>
          <th></th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-space>
        <tr class="clickable-row" (click)="editSpace(space)">
          <td>
            <div class="space-info">
              <div class="space-name">
                @if (isMyDefault(space)) {
                  <i class="pi pi-star-fill text-yellow-500" 
                     pTooltip="Default workspace"
                     tooltipPosition="top"></i>
                }
                {{ space.name }}
              </div>
              @if (space.description) {
                <div class="space-description">{{ space.description }}</div>
              }
            </div>
          </td>
          <td>
            <div class="space-owner">{{ space.owner_email }}</div>
          </td>
          <td>
            <div class="space-role">{{ getRoleDisplayName(space.user_role) }}</div>
          </td>
          <td>
            <div class="space-date">{{ formatDate(space.created_at) }}</div>
          </td>
          <td>
            <p-button 
              icon="pi pi-ellipsis-h"
              [text]="true"
              severity="secondary"
              size="small"
              (click)="showSpaceMenu(space, $event)">
            </p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="empty-message">
            No workspaces found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Mobile Bottom Bar -->
  <div class="mobile-bottom-bar">
    <div class="mobile-bottom-actions">
      <p-button 
        label="New workspace" 
        icon="pi pi-plus"
        (click)="createNewSpace()">
      </p-button>
    </div>
  </div>
</div>